const apiHost = process.env.REACT_APP_API_HOST;

export default {
  baseURL: apiHost,
  withCredentials: true,
};
